import { InsertTicketAssignedGroupRequest, PatchTenantIdentifyRequest, TicketAssignedGroupResponse, TicketConfigClient } from 'services/tenantManagementService';
import { getTenantId } from 'features/Tenant/tenantUtils';
import { FetchingActionType, PersistItemsActionType } from 'features/Persist/actionTypes';
import { tryCatchJsonByAction } from 'utils/fetchUtils';
import store from 'base/reducer/store';

export const getTicketAssignedGroupsAction = (supportOrganizationId: number | undefined) => {
	const tenantId = getTenantId()!;
	const client = new TicketConfigClient();
	return client.getAssignedGroups(tenantId, supportOrganizationId);
}

export const createTicketAssignedGroupAction = (model: InsertTicketAssignedGroupRequest) => {
	const tenantId = getTenantId()!;
	const client = new TicketConfigClient();
	return client.createAssignedGroup(tenantId, model);
}

export const deleteTicketAssignedGroupAction = (id: number) => {
	const tenantId = getTenantId()!;
	const client = new TicketConfigClient();
	return client.deleteAssignedGroup(tenantId, id);
}

export const updateTicketAssignedGroupsAction = (model: PatchTenantIdentifyRequest) => {
	const tenantId = getTenantId()!;
	const client = new TicketConfigClient();
	return client.patchAssignedGroup(tenantId, model);
}

export const persistTicketAssignedGroupsAction = async () => {
	const state = store.getState();

	if (state.persistedTicketAssignedGroup.fetching) {
		return;
	}

	store.dispatch(setTicketAssignedGroupsFetchingAction(true));

	const response = await tryCatchJsonByAction(getTicketAssignedGroupsAction);
	if (response.success) {
		store.dispatch(setTicketAssignedGroupsAction(response.items || []));
	} else {
		store.dispatch(setTicketAssignedGroupsFetchingAction(false));
	}
}

// redux

export const TICKET_ASSIGNED_GROUP_FETCHING = 'TICKET_ASSIGNED_GROUP_FETCHING';
export const TICKET_ASSIGNED_GROUP_SET = 'TICKET_ASSIGNED_GROUP_SET';

const setTicketAssignedGroupsFetchingAction = (fetching: boolean): FetchingActionType => {
	return {
		type: TICKET_ASSIGNED_GROUP_FETCHING,
		fetching
	}
}

const setTicketAssignedGroupsAction = (items: TicketAssignedGroupResponse[]): PersistItemsActionType<TicketAssignedGroupResponse> =>  {
	return {
		type: TICKET_ASSIGNED_GROUP_SET,
		items
	}
}
